import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SortOrder } from '@cpak/adp-cpak-bff-service-models';

import { FetcherService } from './fetcher/fetcher.service';
import {
  UserRouteBox,
  UserRouteInboxOutboxSortOptions,
} from '@cpak/adp-cpak-quotes-service-models/dist/business/routes/get-user-inbox-outbox';
import { GetInboxOutboxRoutesPayload } from '@cpak/adp-cpak-bff-service-models/dist/api/routes/get-inbox-outbox-routes/response-payload';
import { PaginationConfig } from '@cpak/consts';
import { FetcherParams } from './fetcher/fetcher.types';
import { ALLCOUNTRY } from './countries-territories/countries-const';
@Injectable({
  providedIn: 'root',
})
export class InboxOutboxRoutesFetchService {
  constructor(private fetcher: FetcherService) {}

  public getInboxOutboxRoutes(
    userId: string,
    routeBox: UserRouteBox[],
    countryIds: string,
    territoryIds: string[] = [],
    sort: UserRouteInboxOutboxSortOptions,
    sortOrder: SortOrder,
    limit = PaginationConfig.limit,
    offset = PaginationConfig.startPage
  ): Observable<GetInboxOutboxRoutesPayload | null> {
    const isAllCountries = countryIds === ALLCOUNTRY;
    const effectiveCountryIds = isAllCountries ? '' : countryIds;

    const paramsAllTerritories: FetcherParams = {
      userId,
      routeBox,
      countryIds: effectiveCountryIds,
      sort,
      sortOrder,
      limit,
      offset,
      unassigned: isAllCountries,
    };
    if (countryIds === ALLCOUNTRY) {
      delete paramsAllTerritories['countryIds'];
    }

    const paramsExplicitTerritories: FetcherParams = { ...paramsAllTerritories, territoryIds };
    const params: FetcherParams = territoryIds.length ? paramsExplicitTerritories : paramsAllTerritories;

    return this.fetcher.get(`/api/pages/dashboard/routes`, params);
  }
}
